import { Component, ViewChild, ElementRef } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { NodeService } from '../../Services/api-nodeservice';
import { Api } from '../../Model/api-model';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
@Component({
  selector: 'app-document',
  templateUrl: './document.component.html'
})
export class DocumentComponent{
    

    constructor(private nodeService: NodeService,private router: Router,private httpClient: HttpClient) { 
      localStorage.setItem("is_cuurent_nav_aem","y");
    }


    products: any = [];

    tempJsonString:string;
    supportPage=false;

    ngOnInit(){
    
      this.httpClient.get(environment.getAemurl()+"/static_content/support-page.json").subscribe(data =>{
      this.tempJsonString = JSON.stringify(data);
      this.supportPage=true;

       var re = /content\/dam\/developerportal_aetna_com/gi; 
       this.tempJsonString=this.tempJsonString.replace(re,'managedcontent');

       this.products=JSON.parse(this.tempJsonString);
      
       
      })
    }




    ngAfterViewInit() {
      // Hack: Scrolls to top of Page after page view initialized
      let top = document.getElementById('top');
      if (top !== null) {
        top.scrollIntoView();
        top = null;
      }
    }


    ngAfterViewChecked(){
      document.querySelectorAll('h1')
      .forEach((input) => {
        var att = document.createAttribute("class");       // Create a "class" attribute
        att.value = "aem-h1";                           // Set the value of the class attribute
        input.setAttributeNode(att); 

         }
       
      ); //end for h1


      document.querySelectorAll('h2')
      .forEach((input) => {
        var att = document.createAttribute("class");       // Create a "class" attribute
        att.value = "aem-h2";                           // Set the value of the class attribute
        input.setAttributeNode(att); 

         }
       
      ); //end for h2

      document.querySelectorAll('h3')
      .forEach((input) => {
        var att = document.createAttribute("class");       // Create a "class" attribute
        att.value = "aem-h3";                           // Set the value of the class attribute
        input.setAttributeNode(att); 

         }
       
      ); //end for h3


    


  }

}